import { useEffect, useState } from 'react'
import { cn } from '../lib/utils'

export default function StreakCelebrationOverlay({ open, currentStreak, onClose }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (open) {
      setIsVisible(true)
      // Small delay before starting animation
      setTimeout(() => setIsAnimating(true), 50)
      
      // Auto close after 2.5 seconds
      const timer = setTimeout(() => {
        setIsAnimating(false)
        setTimeout(() => {
          setIsVisible(false)
          onClose?.()
        }, 300)
      }, 2500)
      
      return () => clearTimeout(timer)
    } else {
      setIsAnimating(false)
      setTimeout(() => setIsVisible(false), 300)
    }
  }, [open, onClose])

  if (!isVisible) return null

  return (
    <div 
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm transition-opacity duration-300",
        isAnimating ? "opacity-100" : "opacity-0"
      )}
      onClick={() => {
        setIsAnimating(false)
        setTimeout(() => {
          setIsVisible(false)
          onClose?.()
        }, 300)
      }}
    >
      <div 
        className={cn(
          "flex flex-col items-center gap-4 p-8 rounded-3xl bg-gradient-to-b from-orange-500/20 to-red-500/20 border border-orange-500/30 transition-all duration-500",
          isAnimating 
            ? "scale-100 opacity-100 translate-y-0" 
            : "scale-75 opacity-0 translate-y-4"
        )}
      >
        {/* Fire emoji with bounce animation */}
        <div 
          className={cn(
            "text-7xl transition-transform duration-700",
            isAnimating ? "animate-bounce-fire" : ""
          )}
          style={{
            animation: isAnimating ? 'bouncefire 0.6s ease-in-out' : 'none',
            textShadow: '0 0 30px rgba(251, 146, 60, 0.5)'
          }}
        >
          🔥
        </div>
        
        {/* +1 badge */}
        <div 
          className={cn(
            "px-4 py-2 rounded-full bg-orange-500 text-white font-bold text-2xl shadow-lg shadow-orange-500/50 transition-all duration-500 delay-100",
            isAnimating ? "scale-100 opacity-100" : "scale-50 opacity-0"
          )}
        >
          +1
        </div>
        
        {/* Text */}
        <div 
          className={cn(
            "text-center transition-all duration-500 delay-200",
            isAnimating ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
          )}
        >
          <p className="text-xl font-bold text-white mb-1">¡Racha mantenida!</p>
          <p className="text-orange-300">
            Racha actual: <span className="font-bold text-white">{currentStreak} días</span>
          </p>
        </div>
      </div>

      <style>{`
        @keyframes bouncefire {
          0%, 100% {
            transform: scale(1) rotate(0deg);
          }
          25% {
            transform: scale(1.2) rotate(-5deg);
          }
          50% {
            transform: scale(0.95) rotate(5deg);
          }
          75% {
            transform: scale(1.1) rotate(-3deg);
          }
        }
      `}</style>
    </div>
  )
}
